// Redux action types
export const INITIATE = 'one-state-receive-communication/initiate';
export const STATUS = 'one-state-receive-communication/status';
export const REINIT = 'one-state-receive-communication/reinit';